import { isValidFontUrl } from '@shared/utils'
import store from '@/store/store'
import * as C from '@shared/constants'
import ls from '@/local-storage'

const debug = require('debug')('sbox:font')

// An extension can be loaded in multiple channels, in the same
// browser. Meaning, localStorage can contain keys for multiple channels.
export async function loadFontAndGetFontStyle (opts) {
    const { fontUrl, fontKey, mutation, text } = opts
    debug('loadFontAndGetFontStyle', opts)

    store.commit(mutation, { state: C.STATE_DEFAULT })

    if (!isValidFontUrl(fontUrl)) {
        return null
    }

    store.commit(mutation, { state: C.STATE_LOADING })

    const urlObj = new URL(fontUrl)
    if (text) {
        // https://developers.google.com/fonts/docs/getting_started#optimizing_your_font_requests
        urlObj.searchParams.set('text', text)
    }

    try {
        const url = urlObj.href
        await loadFont(url)
    } catch (err) {
        store.commit(mutation, { state: C.STATE_ERROR })
        debug('Deleting stored font b/c failed to load', { fontKey, fontUrl })
        deletedStoredFont(fontKey)
        return null
    }

    store.commit(mutation, { state: C.STATE_SUCCESS })
    storeFont(fontKey, fontUrl)

    // If there are multiple families, only the first one will be used.
    // Multiple fonts are not supported yet, or ever.
    const familyParam = urlObj.searchParams.get('family')
    if (!familyParam) { return null }

    const fontStyle = familyParamToStyle(familyParam)
    return fontStyle
}

// TODO: If channel switching becomes a thing in the future, you might want
// to remove all <link/> tags created for each channel.
export async function loadFont (fontUrl) {
    const selector = `link[rel="stylesheet"][href="${fontUrl}"]`
    let $link = document.head.querySelector(selector)
    if ($link) {
        debug('font already loaded', fontUrl)
        return
    }
    $link = document.createElement('link')
    $link.rel = 'stylesheet'
    $link.href = fontUrl

    return new Promise((resolve, reject) => {
        $link.onload = resolve
        $link.onerror = reject
        document.head.appendChild($link)
    })
}

const storeFont = (fontKey, fontUrl) => ls.setItem(fontKey, fontUrl)
const deletedStoredFont = fontKey => ls.removeItem(fontKey)

export const getStoredFont = (fontKey) => {
    const fontUrl = ls.getItem(fontKey)

    if (!isValidFontUrl(fontUrl)) {
        debug('Deleting stored font b/c invalid url', { fontKey, fontUrl })
        deletedStoredFont(fontKey)
        return null
    } else {
        return fontUrl
    }
}

// https://fonts.googleapis.com/css2?family=Oswald:wght@300&display=swap
// https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap
// style values: wght, ital
export function familyParamToStyle (familyParam) {
    const [family, style, weight] = familyParam.split(/:|@/)
    // cl({family, style, weight})
    // NOTE: style and weight can be csv values.
    //
    // Explicitly setting the font-weight CSS doesn't seem to be required,
    // the proper weight is rendered. Just need to correctly parse
    // the font family.
    const fontStyle = {
        fontFamily: `'${family}', sans-serif`
    }

    return fontStyle
}
